/**
 * Creates a proxy object for the target with overwritten properties.
 * Attention: 1. Due to proxy polyfill restrictions real JS class objects are not fully supported:
 *               in polyfill mode class methods cannot be overridden here.
 *               Pseudo class (such as OL classes) are fully supported.
 *            2. In proxy polyfill mode (IE11) new properties are not allowed for proxy and target(!) after proxy is created.
 *               A workaround is to define the expected new properties with dummy values before proxy creation.
 *
 * @param target - A target object to wrap with Proxy
 * @param properties - {object} Properties which override or extends own properties of the target object
 * @return {object} A proxied object
 */
export function createProxy (target, properties = {}) {
  return new Proxy(target,
    {
      get (object, property) {
        if (property in properties) {
          return properties[property];
        }

        if (typeof target[property] === 'function') {
          return function () {
            return target[property].apply(target, arguments);
          };
        }

        return target[property];
      }
    });
}
